export default __webpack_public_path__ + "static/media/hd4.e43bf0c6.webp";